import MenuLink from '../MenuLink';
import styles from './Menu.module.css';

export default function Menu() {
    return (
        <header>
            <nav className={styles.navegacao}>
            <MenuLink to="/">
                    Trajetória
                </MenuLink>
                <MenuLink to="/projects">
                    Projetos
                </MenuLink>
                
            </nav>
        </header>
    )
}